import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import SchemaForm from "../components/SchemaForm";
import FormUtils from "../lib/FormUtils";
import { save } from "../actions/types";
import * as alertActions from "../actions/alerts";
import TypeHeader from "../components/TypeHeader";

@connect(null)
export default class Single extends Component {
  static propTypes = {
    type: PropTypes.object.isRequired
  };

  state = {
    fieldsToValidate: []
  };

  getSchema() {
    const { type } = this.props;
    if (!type) return null;
    return FormUtils.getContentSchema(type, type);
  }

  onSubmit = async value => {
    const { dispatch, type } = this.props;
    return await dispatch(save(value, type.id));
  };

  validate = async () => {
    const { fieldsToValidate } = this.state;
    await Promise.all(fieldsToValidate.map(field => field.validate()));
    this.setState({ fieldsToValidate: [] });
  };

  validateOnSubmit = component => {
    this.setState(prevState => ({
      fieldsToValidate: [...prevState.fieldsToValidate, component]
    }));
  };

  render() {
    const schema = this.getSchema();
    const { type } = this.props;

    return (
      <div style={{ height: "100%" }}>
        <div className="content scroll-container">
          <TypeHeader type={type} />
          <div className="edit-content">
            <SchemaForm
              asyncValidate={this.validate}
              context={{
                validateOnSubmit: this.validateOnSubmit
              }}
              schema={schema}
              value={type}
              onSubmit={this.onSubmit}
            />
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./app/containers/Single.js